import { WishListActionTypes } from '../../../enums/ActionEnums';
export const wishListActions = {
    initWishListLister: () => ({
        type: WishListActionTypes.LISTER_INIT,
    }),
    getWishListProducts: () => ({
        type: WishListActionTypes.GET_PRODUCTS,
    }),
    updateWishListProducts: (payload) => ({
        type: WishListActionTypes.UPDATE_PRODUCTS,
        payload,
    }),
    toggleProduct: (payload) => ({
        type: WishListActionTypes.TOGGLE_PRODUCT,
        payload,
    }),
    addProduct: (payload) => ({
        type: WishListActionTypes.ADD_PRODUCT,
        payload,
    }),
    removeProduct: (payload) => ({
        type: WishListActionTypes.REMOVE_PRODUCT,
        payload,
    }),
    getWishListListerProducts: () => ({
        type: WishListActionTypes.LISTER_GET_PRODUCTS,
    }),
    setWishListerListerProducts: (payload) => ({
        type: WishListActionTypes.LISTER_SET_PRODUCTS,
        payload,
    }),
    login: () => ({
        type: WishListActionTypes.LOGIN,
    }),
    loginFailed: () => ({
        type: WishListActionTypes.LOGIN_FAILED,
    }),
    logout: () => ({
        type: WishListActionTypes.LOGOUT,
    }),
    loggedIn: () => ({
        type: WishListActionTypes.LOGGED_IN,
    }),
    loggedOut: () => ({
        type: WishListActionTypes.LOGGED_OUT,
    }),
    setFetchStatus: (payload) => ({
        type: WishListActionTypes.LISTER_SET_FETCH_STATUS,
        payload,
    }),
    updateWishListPage: (payload) => ({
        type: WishListActionTypes.LISTER_UPDATE_PAGE,
        payload,
    }),
    getDeliveryPromise(payload) {
        return { type: WishListActionTypes.LISTER_GET_DELIVERY_PROMISE, payload };
    },
    setDeliveryPromise(payload) {
        return { type: WishListActionTypes.LISTER_SET_DELIVERY_PROMISE, payload };
    },
};
